import { BrowserRouter as Router, Routes, Route } from "react-router";
import * as Sentry from "@sentry/react";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import Videos from "./pages/UiElements/Videos";
import Images from "./pages/UiElements/Images";
import Alerts from "./pages/UiElements/Alerts";
import Badges from "./pages/UiElements/Badges";
import Avatars from "./pages/UiElements/Avatars";
import Buttons from "./pages/UiElements/Buttons";
import LineChart from "./pages/Charts/LineChart";
import BarChart from "./pages/Charts/BarChart";
import Calendar from "./pages/Calendar";
import BasicTables from "./pages/Tables/BasicTables";
import FormElements from "./pages/Forms/FormElements";
import Blank from "./pages/Blank";
import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import Home from "./pages/Dashboard/Home";
import AuthGuard from "./components/auth/AuthGuard";
import UsersPage from "./pages/UsersPage";
import CatalogPage from "./pages/CatalogPage";
import OrdersPage from "./pages/OrdersPage";
import BillingPage from "./pages/BillingPage";
import ShippingPage from "./pages/ShippingPage";
import CommunicationsPage from "./pages/CommunicationsPage";
import ContentPage from "./pages/ContentPage";
import PromotionsPage from "./pages/PromotionsPage";
import SettingsPage from "./pages/SettingsPage";
import ThemePage from "./pages/ThemePage";
import ColorPage from "./pages/ColorPage";
import MediaPage from "./pages/MediaPage";
import MarketingSeoPage from "./pages/MarketingSeoPage";
import CartsPage from "./pages/CartsPage";

import { AuthProvider } from "./context/AuthContext";

import CheckoutTestPage from "./pages/CheckoutTestPage";

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <p style={{ padding: "2rem", textAlign: "center" }}>
          Something went wrong. Our team has been notified.
        </p>
      }
      showDialog
    >
      <>
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              {/* Dashboard Layout */}
              <Route element={
                <AuthGuard>
                  <AppLayout />
                </AuthGuard>
              }>


              <Route index path="/" element={<Home />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/carts" element={<CartsPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/checkout-test" element={<CheckoutTestPage />} />
              <Route path="/shipping" element={<ShippingPage />} />
              <Route path="/communications" element={<CommunicationsPage />} />
              <Route path="/content" element={<ContentPage />} />
              <Route path="/marketing-seo" element={<MarketingSeoPage />} />
              <Route path="/promotions" element={<PromotionsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/theme" element={<ThemePage />} />
              <Route path="/color" element={<ColorPage />} />
              <Route path="/media" element={<MediaPage />} />

                {/* Others Page */}
                <Route path="/profile" element={<UserProfiles />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/blank" element={<Blank />} />

                {/* Forms */}
                <Route path="/form-elements" element={<FormElements />} />

                {/* Tables */}
                <Route path="/basic-tables" element={<BasicTables />} />

                {/* Ui Elements */}
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/avatars" element={<Avatars />} />
                <Route path="/badge" element={<Badges />} />
                <Route path="/buttons" element={<Buttons />} />
                <Route path="/images" element={<Images />} />
                <Route path="/videos" element={<Videos />} />

                {/* Charts */}
                <Route path="/line-chart" element={<LineChart />} />
                <Route path="/bar-chart" element={<BarChart />} />
              </Route>

              {/* Auth Layout */}
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />

              {/* Fallback Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </AuthProvider>
      </>
    </Sentry.ErrorBoundary>
  );
}
